/* eslint-disable */

import {
  EXAMPLE_ORGANISATION_ALPHA_ID,
  EXAMPLE_ORGANISATION_ALPHA_NAME,
  EXAMPLE_ORGANISATION_ALPHA_URL,
} from "../../services/constants";
import OrganisationLogo from "../organisation-logo/organisation-logo";
import RaindropTextHeading1 from "../raindrop-text-heading-1/raindrop-text-heading-1.tsx";
import RaindropTextSubtitle from "../raindrop-text-subtitle/raindrop-text-subtitle.tsx";
import RaindropClickable from "../raindrop-clickable/raindrop-clickable.tsx";
import { useNavigate } from "react-router-dom";
import RaindropButton from "../raindrop-button/raindrop-button.tsx";
import ColorIndicator from "../color-indicator/color-indicator.tsx";
import { SausageStyleColor } from "../../logic/enums.ts";
import Spacer from "../spacer/spacer.js";
import PercentageDisplay from "../percentage-display/percentage-display.tsx";

const HydratedBadge = ({ isHydrated }) => {
  if (!isHydrated) {
    return null;
  }
  return (
    <span>
      <i className="fas fa-circle-check text-sm text-color-raindrop-primary"></i>
    </span>
  );
};

const GiveButtonOrTick = ({
  doShow = true,
  organisation,
  isSupporting,
  onAddNewOrganisation = (x) => {},
  onCancelOrganisation = (x) => {},
}) => {
  if (doShow === false) {
    return null;
  }
  return (
    <div className="w-full flex flex-row justify-end">
      {!isSupporting && (
        <RaindropButton
          title="Give"
          onClick={() => onAddNewOrganisation({ organisation: organisation })}
        />
      )}
      {isSupporting && (
        <RaindropButton
          icon="fa-solid fa-check"
          isHidingTitle={true}
          onClick={() => onCancelOrganisation({ organisation: organisation })}
        />
      )}
    </div>
  );
};

const OrganisationListElement = ({
  id = EXAMPLE_ORGANISATION_ALPHA_ID,
  name = EXAMPLE_ORGANISATION_ALPHA_NAME,
  subtitle = "Mental Health for Children",
  isHydrated = false,
  presignedUrl = EXAMPLE_ORGANISATION_ALPHA_URL,
  percentage = null,
  onAddNewOrganisation = (x) => {},
  onCancelOrganisation = (x) => {},
  doShowGiveButton = true,
  doShowColorIndicator = false,
  organisation,
  isSupporting = true,
  onClick = null,
  color = SausageStyleColor.Pink,
  isClickable = true,
}) => {
  const navigate = useNavigate();

  if (onClick === null) {
    onClick = () => {
      navigate(`/raindrop/organisation/${id}`);
    };
  }
  return (
    <RaindropClickable
      onClick={onClick}
      additionalClasses="w-full"
      isDisabled={!isClickable}
    >
      <div id={id} className="flex flex-row  w-full gap-4 items-center">
        <OrganisationLogo src={presignedUrl} />
        <div className="flex flex-col w-full truncate">
          <RaindropTextSubtitle className="truncate">
            Organisation
          </RaindropTextSubtitle>
          <div className="flex flex-row items-center gap-2 w-full">
            <RaindropTextHeading1 className="truncate ">
              {name}
            </RaindropTextHeading1>

            <HydratedBadge isHydrated={isHydrated} />
          </div>
        </div>

        {percentage && <PercentageDisplay value={percentage} max={100} />}
        <ColorIndicator doShow={doShowColorIndicator} color={color} />
        <GiveButtonOrTick
          doShow={doShowGiveButton}
          organisation={organisation}
          isSupporting={isSupporting}
          onAddNewOrganisation={onAddNewOrganisation}
          onCancelOrganisation={onCancelOrganisation}
        />
      </div>
    </RaindropClickable>
  );
};

export default OrganisationListElement;
